import { DataSource, Layout, LayoutHeader, Table } from "@mcleod/components";

export abstract class AutogenLayoutDriverManagerProfileList extends Layout {
    layoutheaderDMProfileList: LayoutHeader;
    sourceDriverManagerProfile: DataSource;
    tableDriverMgrProfileSearch: Table;
}
